import { DatabaseRecord } from "../repos/table.repo";

export interface TopUpTransactionModel extends DatabaseRecord {
    waterFactoryId: string;
    objectType: string;
    recordId: string;
    amount: number;
    information: string;
    createdBy: string;
    createdAt?: Date;
    remitterName: string;
    status: string;
    code: number;
    completeDate?: Date;
    bankTransactionId: string;
    payBillInput: string;
    payBillCreator: string;
}

export class TopUpTransactionModelFactory {
    static getEmpty(): TopUpTransactionModel {
        return {
            id: "",
            waterFactoryId: "",
            objectType: "",
            recordId: "",
            amount: 0,
            information: "",
            createdBy: "",
            remitterName: "",
            status: "",
            code: 0,
            completeDate: undefined,
            bankTransactionId: "",
            payBillInput: "",
            payBillCreator: ""
        };
    }
}